import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import TranslationContext from "../../providers/TranslationContext";
import ValidationContext from "../../providers/ValidationContext";
import { validateField } from "../../validation/formValidation";

interface Props {
  label?: string;
  id?: string;
  defaultValue?: any;
  dataField: string;
  isPassword?: boolean;
  formData: any;
  setStateMethod?: any;
  setCustomStateMethod?: any;
  disabled?: boolean;
  decimalPlaces?: number;
  customLeftCols?: any; // for example col-sm-3
  customRightCols?: any; // for example col-sm-9
  isRequired?: boolean;
  min?:number;
  max?:number;
  step?:number;
}

export const NumericBox = (props: Props) => {
  const { t } = useTranslation();
  const popupModel = useContext(TranslationContext) as any;
  const prefix = popupModel.prefix;

  const [isValid, setIsValid] = useState(true);
  const [validationModel, setValidationModel] = useState<any>();
  const [isRequired, setIsRequired] = useState(false);

  const formValidationModel = useContext(ValidationContext) as any;
  const fieldValidationModel = formValidationModel?.fields?.[props.dataField];


  useEffect(() => {
    if (fieldValidationModel) {
      setIsValid(fieldValidationModel?.isValid !== undefined ? fieldValidationModel.isValid : true);
      setValidationModel(fieldValidationModel);
    }
  }, [fieldValidationModel?.isValid]);

  useEffect(() => {
    const fieldValidationModel = formValidationModel?.fields?.[props.dataField];
    if (fieldValidationModel) {
      setValidationModel(fieldValidationModel);
      setIsRequired(props.isRequired ?? fieldValidationModel?.isRequired);
    }
  }, []);

  let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
    } col-form-label zvlabel`;

  let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

  let label = props.label;
  if (prefix) {
    label = t(`${prefix}.Fields.${props.dataField}`);
  }

  return (
    <>
      <div className={isValid ? "row" : "row invalid"}>
        {label && (
          <label htmlFor={props.id} className={leftColumnClass}>
            {label}{isRequired && <span className="required">*</span>}
          </label>
        )}

        <div className={rightColumnClass}>
          <NumericFormat
        
            value={props.defaultValue}
            decimalSeparator=','
            decimalScale={props.decimalPlaces ? props.decimalPlaces : 2}
            className={`form-control`}
            disabled={props.disabled}
            onFocus={(event) => event.target.select()}
            onChange={(event) => {
              let value = event.target.value ? parseFloat(event.target.value.replace(',', '.')) : null;
              validateField(value, validationModel);
              if (props.setStateMethod) {
                props.formData[props.dataField] = value;
                props.setStateMethod({ ...props.formData });
              }
              else if (props.setCustomStateMethod) {
                props.setCustomStateMethod(props.dataField, props.id, value)
              }
            }}
          />
          {validationModel?.errors &&
            <span className="validation-errors">
              {validationModel?.errors.map(e => {
                return e;
              })}
            </span>
          }
        </div>
      </div>
    </>
  );
};
